import React, { useMemo, useState } from 'react';
import moment from 'moment';
import { makeStyles, Grid, Divider, Chip, TextField } from '@material-ui/core';
import { Dialog, IconButton, Panel, Typography } from 'components';
import { addHolidayShift, updateHolidayShift } from 'store/firebase';
import { STATUSES } from 'config/leaveStatus';
import { Table, TableCell, TableHead, TableRow, TableBody } from 'components/table';
import TableCellHeader from 'views/shift/TableCellHeader';
import { useAlert, useReduxDispatch } from 'store/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { fetchHolidays } from 'store/holiday';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 30,
  },
  root: {
    '& .MuiChip-label': {
      fontSize: 13,
    },
    '& .MuiChip-deleteIcon': {
      width: 14,
      height: 14,
    },
  },
}));

const STATUS_KEYS = {};

// eslint-disable-next-line no-return-assign
STATUSES.forEach((e) => (STATUS_KEYS[e.id] = e.label));

const TransactionDetail = ({ selected, shiftMaster, setSelected, setAction }) => {
  const classes = useStyles();
  const { alertWaiting, alertSuccess, alertError } = useAlert();
  const [openAddShiftDialog, setOpenAddShiftDialog] = useState(false);
  const [value, setValue] = useState([]);
  const getHolidayList = useReduxDispatch(fetchHolidays);
  const [openDelete, setOpenDelete] = useState(false);

  const handleUpdateHoliday = (...payload) => {
    alertWaiting();
    updateHolidayShift(...payload)
      .then((size) => {
        alertSuccess(`Berhasil sinkronisasi libur ${payload[0]}, (${size} diupdate) `);
        if (!payload[3]) refetchHolidayList();
      })
      .catch((err) => alertError(err.message || err));
    setOpenAddShiftDialog(false);
  };

  const handleAddShift = () => {
    alertWaiting();
    addHolidayShift(selected, value)
      .then((size) => {
        refetchHolidayList();
        alertSuccess('Berhasil menambahkan shift libur!');
      })
      .catch((err) => alertError(err?.message || err));
    setOpenAddShiftDialog(false);
  };

  const refetchHolidayList = async () => {
    let seletedData = await getHolidayList();
    seletedData = seletedData.payload?.find(
      (updatedItem) => updatedItem.holidayId === selected.holidayId
    );
    setSelected(seletedData);
  };

  const shiftOptions = useMemo(() => {
    if (shiftMaster.data.length > 0) {
      return shiftMaster.data
        .filter((e) => e.dayOff === undefined || e.dayOff === false)
        .map((e) => ({ ...e }));
    } else return [];
  }, [shiftMaster]);

  return (
    <>
      <Grid item xs={9} md={7}>
        <Panel>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 20,
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontSize: 32,
                fontWeight: 800,
                marginRight: 12,
              }}
            >
              Hari Libur
            </Typography>
          </div>
          <Divider style={{ marginBottom: 20 }} />
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <IconButton
              tooltip="Hapus Libur"
              icon="trash"
              color="#A5B3BA"
              style={{ marginRight: 8 }}
              onClick={() => setOpenDelete(true)}
            />
          </div>
          <Grid container className={classes.infoContainer}>
            <Grid item xs={5} sm={3}>
              <Typography variant="body1" style={{ width: 200 }}>
                Keterangan Libur
              </Typography>
            </Grid>
            <Grid item xs={7} sm={9}>
              <Typography variant="body1" type="bold" style={{ textTransform: 'uppercase' }}>
                {selected?.title}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.infoContainer}>
            <Grid item xs={5} sm={3}>
              <Typography variant="body1" style={{ width: 200 }}>
                Tanggal Mulai
              </Typography>
            </Grid>
            <Grid item xs={7} sm={9}>
              <Typography variant="body1" type="bold">
                {moment(selected?.startDate).format('D MMMM YYYY')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.infoContainer}>
            <Grid item xs={5} sm={3}>
              <Typography variant="body1" style={{ width: 200 }}>
                Tanggal Berakhir
              </Typography>
            </Grid>
            <Grid item xs={7} sm={9}>
              <Typography variant="body1" type="bold">
                {moment(selected?.endDate).format('D MMMM YYYY')}
              </Typography>
            </Grid>
          </Grid>
          <div style={{ textAlign: 'right' }}>
            <Chip
              clickable
              size="small"
              label="Tambah Shift"
              icon={
                <FontAwesomeIcon
                  icon="plus"
                  size="sm"
                  style={{
                    marginRight: 5,
                  }}
                />
              }
              style={{
                marginRight: 6,
                marginBottom: 8,
                padding: 8,
                borderRadius: 25,
                backgroundColor: '#c2e1fb',
              }}
              onClick={() => setOpenAddShiftDialog(true)}
            />
          </div>
          {/* shift detail */}
          {/* <Table
            pagination={10}
            rowCount={selected.shifts?.length || 0}
            pagingProps={{
              color: '#0073d1',
              position: 'right'
            }}
          >
            <TableHead>
              <TableRow border='bottom'>
                <TableCellHeader title="Nama Shift" />
                <TableCellHeader title="Jam Mulai" />
                <TableCellHeader title="Jam Selesai" />
                <TableCellHeader title="Action" />
              </TableRow>
            </TableHead>
            <TableBody>
              {(searchFilter) =>
								  searchFilter(selected.shifts).map(
								    (item, key) => (
                    <TableRow
                      border='bottom'
                      style={{ height: 50 }}
                    >
                      <TableCell>
                        <Typography variant='body1'>
                          {item.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant='body1' style={{ marginLeft: 30 }}>
                          {item.startTime}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant='body1' style={{ marginLeft: 30 }}>
                          {item.endTime}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          icon='minus'
                          color='#A5B3BA'
                          style={{ marginRight: 8 }}
                          onClick={() => handleUpdateHoliday(item.name, +selected.startDate, +selected.endDate, false, selected)}
                        />
                        <IconButton
                          icon='sync'
                          color='#A5B3BA'
                          onClick={() => handleUpdateHoliday(item.name, +selected.startDate, +selected.endDate, true)}
                        />
                      </TableCell>
                    </TableRow>
								    )
								  )
              }
            </TableBody>
          </Table> */}
          <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
            <Table
              pagination={10}
              rowCount={selected.shifts?.length || 0}
              pagingProps={{
                color: '#0073d1',
                position: 'right',
              }}
            >
              <TableHead>
                <TableRow border="bottom">
                  <TableCellHeader title="Nama Shift" />
                  <TableCellHeader title="Jam Mulai" />
                  <TableCellHeader title="Jam Selesai" />
                  <TableCellHeader title="Action" />
                </TableRow>
              </TableHead>
              <TableBody>
                {(searchFilter) =>
                  searchFilter(selected.shifts).map((item, key) => (
                    <TableRow border="bottom" style={{ height: 50 }}>
                      <TableCell>
                        <Typography variant="body1">{item.name}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body1" style={{ marginLeft: 30 }}>
                          {item.startTime}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body1" style={{ marginLeft: 30 }}>
                          {item.endTime}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          icon="minus"
                          tooltip="Hapus Shift"
                          color="#A5B3BA"
                          style={{ marginRight: 8 }}
                          onClick={() =>
                            handleUpdateHoliday(
                              item.name,
                              +selected.startDate,
                              +selected.endDate,
                              false,
                              selected
                            )
                          }
                        />
                        <IconButton
                          icon="sync"
                          tooltip="Sinkronisasi ulang"
                          color="#A5B3BA"
                          onClick={() =>
                            handleUpdateHoliday(
                              item.name,
                              +selected.startDate,
                              +selected.endDate,
                              true
                            )
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </div>
        </Panel>
      </Grid>
      <Dialog
        open={openAddShiftDialog}
        onClose={() => {
          setOpenAddShiftDialog(false);
          setValue([]);
        }}
        action={{
          label: 'Tambahkan Shift',
          onClick: () => {
            handleAddShift();
            setValue([]);
          },
        }}
        title="Tambah Shift"
        maxWidth="sm"
        fullWidth
      >
        <Grid
          style={{
            height: 300,
          }}
        >
          <div>
            <Autocomplete
              ChipProps={{
                style: {
                  display: 'none',
                },
              }}
              fullWidth
              className={classes.root}
              multiple
              options={shiftOptions}
              onChange={(_, value) => setValue(value)}
              getOptionLabel={(option) => option.name}
              renderOption={(option) => <>{`${option.name}`}</>}
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={{
                    fontSize: 14,
                  }}
                  label="Pilih Shift"
                  variant="standard"
                />
              )}
            />
          </div>
          <div
            style={{
              marginTop: 20,
            }}
          >
            {value.map((item, index) => (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '4px 0',
                  borderBottom: '1px solid #A5B3BA',
                }}
              >
                <Typography
                  style={{
                    fontSize: 14,
                  }}
                >
                  {item.name} {item.startTime}-{item.endTime}
                </Typography>
              </div>
            ))}
          </div>
        </Grid>
      </Dialog>
      <ConfirmDeleteDialog
        open={openDelete}
        onClose={setOpenDelete}
        tobeDeletedItem={selected}
        setAction={setAction}
      />
    </>
  );
};

export default TransactionDetail;
